<project-details-breadcrumb-version-header
  [project]="project ?? projectHeader"
  [version]="version"
  [exclude]="excludedLabels"
  [title]="bcTitle"
  [breadcrumbs]="breadcrumbs"
  [menu]="status == STATUS_NOT_ACCESS_DONE ? [] : menu"
  (action)="onMenuClick($event)"
  (statusAction)="onStatusUpdate($event)"
></project-details-breadcrumb-version-header>

<div class="loader">
  <div class="dimmed" [hidden]="status != STATUS_LOADING" >
  <div class="dimmed_flex">
    <div class="dimmed_content dimmed_versions">
      <div class="dimmed_title"></div>
      <div class="dimmed_subtitle"></div>
      <div class="dimmed_subtitle"></div>
    </div>
    <div class="dimmed_status"></div>
  </div>
  </div>
</div>

<div *ngIf="status == STATUS_DONE" class="version" [ngClass]="{'with-overlay': modalView != VIEW_MODAL_NONE}">
  <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == VIEW_SELF_FEEDBACK_DONE"
    [type]="'done'"
    [message]="'Request sent'"
    [text]="'Your self request feedback has been successfully sent'"
    [buttonText]="'Done'"
    (action)="onModalDismiss($event)">
  </core-layout-modal-feedback>
  <core-layout-modal-feedback class="modal-feedback modal-reminder-success" *ngIf="modalView == VIEW_APPROVAL_REMINDER_DONE"
    [type]="'done'"
    [message]="'Approval reminder sent'"
    [buttonText]="'Done'"
    (action)="onModalDismiss($event)">
  </core-layout-modal-feedback>
  <core-layout-modal-feedback class="modal-feedback modal-reminder-error" *ngIf="modalView == VIEW_APPROVAL_REMINDER_ERROR || modalView == VIEW_SELF_FEEDBACK_ERROR"
    [type]="'fail'"
    [message]="'Error'"
    [text]="'Something went wrong. Please try again. If the error persists, please reach out to our support team through the <strong>Help Me button</strong>.'"
    [buttonText]="'Go back'"
    (action)="onModalDismiss($event)">
  </core-layout-modal-feedback>
  <div *ngIf="notLinkedArtwork" class="alert-version">
    <core-helpers-box-alert-message-icon [text]="'The Artwork is not linked to this project.'"
      [icon]="'alert'"></core-helpers-box-alert-message-icon>
  </div>
  <!-- we need the project for links to plugins, in the case -->
    <version-details-content [project]="project ?? projectHeader"></version-details-content>
</div>
<div class="version-details-forbidden"  *ngIf="status == STATUS_NOT_ACCESS_DONE && version != null">
  <core-versions-detail-box
      [version]="version"
  ></core-versions-detail-box>
  <core-helpers-box-alert-message-icon
    [text]="'You don’t have permission to see this artwork'"
    [icon]="'alert'"
  ></core-helpers-box-alert-message-icon>
</div>

<core-helpers-box-http-error
    *ngIf="status == STATUS_NOT_FOUND"
    [code]="404"
    [message]="'Not found.'"
></core-helpers-box-http-error>

<core-helpers-box-http-error
    *ngIf="status == STATUS_ERROR"
    [code]="500"
    [message]="'Error. Check your url'"
></core-helpers-box-http-error>
